import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { DocumentZipFilters } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface Props {
  caseId: string;
}

interface CreateZipResponse {
  zipExists: boolean;
  jobId?: string;
  inProgress?: boolean;
  filterHash?: string;
}

export const useCreateDocumentZip = ({ caseId }: Props) => {
  const { getFetchConfig } = useGetFetchConfig();

  const createDocumentZip = async (filters?: DocumentZipFilters): Promise<CreateZipResponse> => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: { 
        caseId,
        ...filters 
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/docs/create-zip`, fetchConfig);
    if (!response.ok) {
      throw new Error('Failed to create document zip');
    }

    return await response.json();
  };

  const { mutate: createZip, isLoading: isCreatingZip, error } = useMutation(createDocumentZip);

  return { createZip, isCreatingZip, error };
};
